import { Teammate } from 'src/@types/teammates';

export const getRegisteredTeammates = (teammates: Teammate[]) => {
  if (teammates.length === 0) return;
  return teammates.filter((user) => user.has_registered);
};
